// The simulation's own internals (the "Personas: [...]" prompt seed + the raw survey_results /
// analysis JSON) are stripped server-side (GET /chat/simulation/{id} drops the leading
// user/assistant seed turns by role), so the client only receives genuine conversation. We must
// NOT re-guess seeds here by content shape or length: a real question like "[Brand X] what did
// people think?" starts with '[', and a genuine analysis answer can exceed 8000 chars — the old
// heuristic silently deleted both. Just require non-empty content.
export const isDisplayableChatMessage = (content: string): boolean =>
  !!content && content.trim().length > 0;
